import type { TMessages } from '@/types/TMessages'

export const messages = {
  error: 'Что-то пошло не так. Обновите страницу', //
  pageTitle: 'Предложения покупателей по {culture}', //
  pageBreadcrumb: 'Предложения покупателей', //
} satisfies TMessages
